import { useState, useEffect } from "react";
import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;

export default function usePhotos() {
  const [photos, setPhotos] = useState({});
  useEffect(() => {
    axios
      .get(`${BASE}/api/photos`)
      .then((r) => {
        const map = {};
        Object.entries(r.data || {}).forEach(([slot, path]) => {
          map[slot] = `${BASE}/api/files/${path}`;
        });
        setPhotos(map);
      })
      .catch(() => {});
  }, []);
  return photos;
}
